import { CubeBuilder, NOOP_VOID, Place } from 'src/3rds/cube'

import { Places } from './Constants'
import { OverviewPresenter } from './modules/overview'
import { RestrictedPresenter } from './modules/restricted/Restricted.presenter'
import { UserProfilePresenter } from './modules/user-profile'
import { CadastroLotePresenter } from './modules/cadastro-lote'
import { CampanhaPresenter } from './modules/campanha'
import { GrupoManualPresenter } from './modules/grupo-manual'
import { DashboardsPresenter } from './modules/dashboards'
import { BloqueiosPresenter } from './modules/bloqueios'
import { TemplatesPresenter } from './modules/templates'
import { MensagemDiretaPresenter } from './modules/mensagem-direta'
import { moduloSimulador } from './simulador'

let buildOnce = () => {
    CubeBuilder.build({
        overview: {
            presenter: Place.creator(OverviewPresenter, Places, 'overview')
        },
        userProfile: {
            presenter: Place.creator(UserProfilePresenter, Places, 'profile')
        },
        restricted: {
            presenter: Place.creator(RestrictedPresenter, Places, 'restricted')
        },
        cadastroLote: {
            presenter: Place.creator(CadastroLotePresenter, Places, 'cadastroLote')
        },
        campanha: {
            presenter: Place.creator(CampanhaPresenter, Places, 'campanha')
        },
        grupoManual: {
            presenter: Place.creator(GrupoManualPresenter, Places, 'grupoManual')
        },
        dashboards: {
            presenter: Place.creator(DashboardsPresenter, Places, 'dashboards')
        },
        bloqueios: {
            presenter: Place.creator(BloqueiosPresenter, Places, 'bloqueios')
        },
        templates: {
            presenter: Place.creator(TemplatesPresenter, Places, 'templates')
        },
        mensagemDireta: {
            presenter: Place.creator(MensagemDiretaPresenter, Places, 'mensagemDireta')
        },
        // Simulador do WhatsApp: só no pacote de desenvolvimento (E13).
        ...(moduloSimulador
            ? { simulador: { presenter: Place.creator(moduloSimulador.SimuladorPresenter, Places, 'simulador') } }
            : {})
    })

    buildOnce = NOOP_VOID
}

export function buildCube() {
    buildOnce()
    return Places
}
